import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

enum Loyalty {
  FALLBACK = 'FALLBACK',
  TIER1 = 'TIER1',
  TIER2 = 'TIER2',
  TIER3 = 'TIER3',
}

export type LoyaltyType = 'FALLBACK' | 'TIER1' | 'TIER2' | 'TIER3'

export function getYearDifference(date: string): number {
  const currentDate = dayjs()
  return currentDate.diff(date ?? '', 'year')
}

export function getIsValidDate(date: string): boolean {
  if (!date) return false
  const formattedDate = dayjs(date).format('YYYY-MM-DD')
  return dayjs(formattedDate).isValid()
}

export function getLoyaltyType(accountOpeningDate: string): LoyaltyType {
  const isValidDate = getIsValidDate(accountOpeningDate)
  const yearDifference = getYearDifference(accountOpeningDate)

  if (isValidDate === false) return Loyalty.FALLBACK
  if (yearDifference < 5) return Loyalty.TIER1
  if (yearDifference >= 5 && yearDifference < 10) return Loyalty.TIER2
  if (yearDifference >= 10) return Loyalty.TIER3
  return Loyalty.FALLBACK
}
